import { z } from 'zod'

export const basicEntity = z.object({
  id: z.string().optional(),
  creationSystem: z.string().optional(),
  creationKey: z.string().optional(),
  name: z.string().optional(),
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reverificationDataSchema = z.object({
  firstName: z.string(),
  middleNames: z.string(),
  lastName: z.string(),
  industryParticipants: z.array(basicEntity).nullable().optional(),
  employmentStatus: basicEntity.nullable().optional(),
  occupation: basicEntity.nullable().optional(),
  natureOfBetting: basicEntity.nullable().optional(),
})

export type ReverificationData = z.infer<typeof reverificationDataSchema>
